import { globalGentraceConfig, } from "@gentrace/core";
import { PineconePipelineHandler, } from "../pinecone";
class SimplePinecone extends PineconePipelineHandler {
    constructor(config) {
        if (!config) {
            throw new Error("Pinecone configuration with API key and environment is required");
        }
        super({
            gentraceConfig: globalGentraceConfig,
            config,
        });
        this.configProtected = config;
    }
    getConfig() {
        return this.configProtected;
    }
    // @ts-ignore
    Index(index) {
        return this.index(index);
    }
    // @ts-ignore: hack to avoid base class inheritance issues
    index(index) {
        const apiHandler = super.indexInner(index);
        return apiHandler;
    }
}
export { SimplePinecone };
